//==============================
// 設定
//==============================
var minDay = 4;              // 今日から何日後を最短にするか
var maxListSize = 10;        // 選択肢の最大日数
var limitTime = "11:59";     // 締め時間（これを過ぎたら +1日）
var timezoneoffset = 9;      // JST = 9
var WeekChars = ['日','月','火','水','木','金','土'];

var noSendWeekdayList = [];  // 配送不可の曜日（例：['日']）
var noSendDayList = [];      // 配送不可の日付（例：['01/01']）

var pullDownAddWeekDay = true;  // 曜日を表示するか
var pullDownAddHead = true;     // 「指定なし」を追加するか
var pullDownAddHeadtxt = "指定なし";
var pullDownAddYear = true;     // 年を表示するか


//==============================
// 現在日時（タイムゾーン補正）
//==============================
function getToday(){
  return new Date(Date.now() - (timezoneoffset * 60 - new Date().getTimezoneOffset()) * 60000);
}

function getNow(){
  return new Date(Date.now() - (timezoneoffset * 60 - new Date().getTimezoneOffset()) * 60000);
}


//==============================
// 日付文字列生成
//==============================
function getDateString(dateObj){
  var y = dateObj.getFullYear();
  var m = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  var d = ("0" + dateObj.getDate()).slice(-2);
  return y + "/" + m + "/" + d;
}


//==============================
// プルダウン生成
//==============================
function setSelectList(minDayDate){
  var select = document.getElementById("deliveryDate");
  if(!select) return; // セレクトが存在しない場合は終了

  select.innerHTML = "";

  // 「指定なし」
  if(pullDownAddHead){
    var op = document.createElement("option");
    op.value = "";
    op.text = pullDownAddHeadtxt;
    select.appendChild(op);
  }

  // 日付リスト生成
  for(var i = 0; i < maxListSize; i++){
    var d = new Date(minDayDate);
    d.setDate(minDayDate.getDate() + i);

    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    var w = WeekChars[d.getDay()];

    // 配送不可曜日
    if(noSendWeekdayList.includes(w)) continue;

    // 配送不可日付
    var md = ("0"+m).slice(-2) + "/" + ("0"+day).slice(-2);
    if(noSendDayList.includes(md)) continue;

    var option = document.createElement("option");
    option.value = getDateString(d);

    var label = "";
    if(pullDownAddYear) label += y + "年 ";
    label += m + "月" + day + "日";
    if(pullDownAddWeekDay) label += "（" + w + "）";

    option.text = label;
    select.appendChild(option);
  }

  // 以前の選択を復元
  var saved = document.getElementById("dumyDeliveryDate");
  if(saved && saved.value){
    for(var i = 0; i < select.options.length; i++){
      if(select.options[i].value == saved.value){
        select.options[i].selected = true;
      }
    }
  }
}


//==============================
// 起動処理
//==============================
window.addEventListener('DOMContentLoaded', function(){
  var today = getToday();
  var now = getNow();

  // 締め時間処理
  try {
    var deadlineHour = limitTime.split(':')[0];
    var deadlineMinute = limitTime.split(':')[1];
    var deadlineTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), deadlineHour, deadlineMinute);
  } catch(e){
    deadlineTime = today;
  }

  if(now.getTime() > deadlineTime.getTime()){
    today.setDate(today.getDate() + 1);
  }

  var minDayDate = new Date(today);
  minDayDate.setDate(today.getDate() + minDay);

  setSelectList(minDayDate);
});